/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import styles from "./FilterDrawer.module.css";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {
  Close,
  PlayArrowRounded,
  PauseRounded,
  ReplayRounded,
  Forward10Rounded,
  Forward30Rounded,
  Replay10Rounded,
  ShowChartRounded,
} from "@material-ui/icons";
import Button from "@material-ui/core/Button/Button";
import cloneDeep from "lodash/cloneDeep";
import { ThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { constant } from "./../../../shared/constants/constants";
import { clearFilteredGeometry } from "../../../store/actions";
// import Visit from "../Visit/Visit";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#8fa225",
      contrastText: "#fff",
    },
  },
  overrides: {
    MuiToolbar: {
      gutters: {
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
      },
    },
  },
});

class FilterDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDateTime: moment().subtract(1, "hours"),
      endDateTime: moment(),
    };
  }

  // called when component render first time
  componentDidMount() {
    // clear if already replay coordinates are present in redux store
    this.props.clearFilteredGeometry();
    toast.info(constant.SELECT_START_AND_END_TIME_TO_SEE_REPLAY_COORDINATES, {
      autoClose: 8000,
    });
  }

  // set startDateTime in state
  startDateTimeHandler = (date) => {
    this.setState({ startDateTime: date });
  };

  // set endDateTime in state
  endDateTimeHandler = (date) => {
    this.setState({ endDateTime: date });
  };

  // called when click on submit button
  submitHandler = () => {
    // clone all the dates so that to avoid unintentionally overwrite state object
    let startTime = cloneDeep(this.state.startDateTime);
    let endTime = cloneDeep(this.state.endDateTime);

    // difference between startDateTime and endDateTime
    let duration = moment.duration(endTime.diff(startTime));

    //check if startDateTime > endDateTime
    if (startTime.isAfter(endTime)) {
      // show error toast
      toast.error(constant.START_TIME_NOT_GREATER_THAN_END_TIME, {
        autoClose: 3000,
      });
      return;
    }
    // if endDateTime is ahead of more than 24 hours startDateTime show error toast
    if (duration.asHours() > 24) {
      toast.error(constant.END_TIME_NOT_GREATER_24HRS_FROM_START_TIME, {
        autoClose: 3000,
      });
      return;
    }

    this.props.replaySubmitHelper(startTime, endTime, this.props.info.id);
  };

  render() {
    let timer = constant.NOT_APPLICABLE;
    let timerColor = "red";

    if (this.props.timestamp) {
      timer = moment(this.props.timestamp).format("MMM D, HH:mm:ss");
      timerColor = "green";
    } else if (this.props.initialTimestamp) {
      timer = moment(this.props.initialTimestamp).format("MMM D, HH:mm:ss");
      timerColor = "green";
    }

    return (
      <div className={styles.FilterDrawer}>
        <div
          onClick={this.props.closeVehicleDetailDrawer}
          title={constant.CLOSE}
          className={styles.Close}>
          <Close />
        </div>

        <div className={styles.DetailCont}>
          <div style={{ fontSize: "14px", paddingTop: "4px" }}>
            {this.props.info.vehicleName && (
              <div>
                <strong className={styles.HighLt}>
                  {constant.VEHICLE_NAME} :
                </strong>
                <span>{" " + this.props.info.vehicleName}</span>
              </div>
            )}
            {this.props.info.userName && (
              <div>
                <strong className={styles.HighLt}>
                  {constant.USER_NAME} :
                </strong>
                <span>{" " + this.props.info.userName}</span>
              </div>
            )}
            <div>
              <strong className={styles.HighLt}>{constant.STATUS} :</strong>
              <span>{" " + this.props.info.status}</span>
            </div>
            <div>
              <strong className={styles.HighLt}>
                {constant.LAST_UPDATED} :
              </strong>
              <span>{" " + this.props.info.lastUpdated}</span>
            </div>
          </div>
        </div>

        <MuiPickersUtilsProvider utils={MomentUtils}>
          <div className={styles.DateCont}>
            <div className={styles.DateCrd}>
              <ThemeProvider theme={theme}>
                <KeyboardDateTimePicker
                  autoOk
                  variant="inline"
                  ampm={false}
                  disableFuture
                  value={this.state.startDateTime}
                  onChange={this.startDateTimeHandler}
                  label={constant.START_DATE__TIME}
                  strictCompareDates
                  animateYearScrolling
                  maxDateMessage={constant.DATE_SHOULD_NOT_BE_AFTER_END_DATE}
                  maxDate={moment(this.state.endDateTime).subtract(1, "m")}
                />
              </ThemeProvider>
            </div>
            <div className={styles.DateCrd}>
              <ThemeProvider theme={theme}>
                <KeyboardDateTimePicker
                  autoOk
                  variant="inline"
                  ampm={false}
                  disableFuture
                  value={this.state.endDateTime}
                  onChange={this.endDateTimeHandler}
                  label={constant.END_DATE_TIME}
                  strictCompareDates
                  animateYearScrolling
                  minDateMessage={
                    constant.END_DATE_SHOULD_NOT_BE_BEFORE_START_DATE
                  }
                  minDate={moment(this.state.startDateTime).add(1, "m")}
                />
              </ThemeProvider>
            </div>
            <div className={styles.Pdt16}>
              <Button
                onClick={this.submitHandler}
                className={styles.SubmitBtn}
                variant="contained">
                {constant.SUBMIT}
              </Button>
            </div>
          </div>
        </MuiPickersUtilsProvider>
        {this.props.showControls ? (
          <div>
            <div className={styles.TimerCont}>
              <h4>{constant.LOCATION_TIME}</h4>
              <p style={{ color: timerColor }}>{timer}</p>
            </div>

            <div className={styles.CtrlCont}>
              <h3>{constant.CONTROLS}</h3>
              <div className={styles.Ctrl1}>
                {this.props.isPaused ? (
                  <button
                    title={constant.PLAY}
                    className={styles.IconBtn}
                    onClick={this.props.play}>
                    <PlayArrowRounded fontSize="inherit" color="inherit" />
                  </button>
                ) : (
                  <button
                    title={constant.PAUSE}
                    className={styles.IconBtn}
                    onClick={this.props.pause}>
                    <PauseRounded fontSize="inherit" color="inherit" />
                  </button>
                )}

                <button
                  title={constant.RESET}
                  className={styles.IconBtn}
                  onClick={this.props.reset}>
                  <ReplayRounded fontSize="inherit" color="inherit" />
                </button>

                <button
                  title={constant.PLOT_WHOLE_PATH}
                  className={styles.IconBtn}
                  onClick={this.props.plotWhole}>
                  <ShowChartRounded fontSize="inherit" color="inherit" />
                </button>
              </div>
              <div className={styles.Ctrl1}>
                <button
                  title={constant.BACK_10}
                  className={styles.IconBtn}
                  onClick={() => this.props.backward(10)}>
                  <Replay10Rounded fontSize="inherit" color="inherit" />
                </button>
                <button
                  title={constant.FOREWORD_10}
                  className={styles.IconBtn}
                  onClick={() => this.props.forward(10)}>
                  <Forward10Rounded fontSize="inherit" color="inherit" />
                </button>
                <button
                  title={constant.FOREWORD_30}
                  className={styles.IconBtn}
                  onClick={() => this.props.forward(30)}>
                  <Forward30Rounded fontSize="inherit" color="inherit" />
                </button>
              </div>
            </div>
          </div>
        ) : null}
        {/* <Visit /> */}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearFilteredGeometry: () => dispatch(clearFilteredGeometry()),
  };
};
export default connect(null, mapDispatchToProps)(FilterDrawer);
